function toFloat(javaDuration) {
    let duration = javaDuration.substring(2)
    return parseFloat(duration.substring(0, duration.length - 1))
}

function findChildren(json, id) {
    const events = json
        .filter(e => e.startupStep.parentId === id)
        .map(function (item) {
            const children = findChildren(json, item.startupStep.id)
            return {
                data: {
                    name: item.startupStep.name,
                    id: item.startupStep.id,
                    duration: toFloat(item.duration),
                    details: item.startupStep.tags
                },
                children: children
            };
        }).sort((a, b) => b.data.duration - a.data.duration)
    return events;
}

function filter(events, text) {

    return events ? events.filter(event => {
        if (event.data.name.indexOf(text) !== -1) {
            event.include = true
            event.data.children = filter(event.data.children, text)
            return true;
        }
        return false;
    }) : []
}

export {findChildren, filter};